import { getPlainText, getRichText
// @ts-ignore - Missing declaration file for conversations-message-history module
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { AGENT } from 'conversations-message-history/constants/messageUses';
import ContentText from '../atoms/ContentText';
import PrimaryMessage from '../primary-message/components/PrimaryMessage';
import PrimaryMessageContent from '../primary-message/components/PrimaryMessageContent';
import PrimaryMessageContentSection from '../primary-message/components/PrimaryMessageContentSection';
import { jsx as _jsx } from "react/jsx-runtime";
const AvailabilityAutoReplyMessage = ({
  message
}) => {
  const text = getPlainText(message);
  const richText = getRichText(message);
  if (!richText && !text) {
    return null;
  }
  return /*#__PURE__*/_jsx(PrimaryMessage, {
    use: AGENT,
    children: /*#__PURE__*/_jsx(PrimaryMessageContent, {
      children: /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
        children: /*#__PURE__*/_jsx(ContentText, {
          messageId: message.id,
          contentText: richText || text,
          isPartialMessage: false
        })
      })
    })
  });
};
AvailabilityAutoReplyMessage.displayName = 'AvailabilityAutoReplyMessage';
export default AvailabilityAutoReplyMessage;